// Local, rule-based autocorrect — no AI, no network, no credits.
// British-English safe: it NEVER converts -our/-ise/-re/-lling spellings to US,
// and only ever changes words that are explicit typos or clear contractions.

// Common misspellings (British-safe). Keys are lowercase; values keep intended casing.
const TYPOS = {
  teh: "the", hte: "the", taht: "that", thsi: "this",
  adn: "and", anmd: "and", wnat: "want", waht: "what", wiht: "with",
  wtih: "with", jsut: "just", jstu: "just", liek: "like",
  recieve: "receive", recieved: "received", recieving: "receiving",
  beleive: "believe", beleived: "believed", believ: "believe",
  seperate: "separate", seperated: "separated", definately: "definitely",
  occured: "occurred", occuring: "occurring", occassion: "occasion",
  untill: "until", wich: "which", thier: "their", freind: "friend",
  freinds: "friends", becuase: "because", becasue: "because", becuse: "because",
  acheive: "achieve", acheived: "achieved", arguement: "argument",
  calender: "calendar", cemetary: "cemetery", embarass: "embarrass",
  enviroment: "environment", existance: "existence", goverment: "government",
  independant: "independent", occurence: "occurrence", persistant: "persistent",
  wierd: "weird", writting: "writing", tommorow: "tomorrow", tommorrow: "tomorrow",
  gaurd: "guard", knowlege: "knowledge", lenght: "length", neccessary: "necessary",
  publically: "publicly", suprise: "surprise", suprised: "surprised", truely: "truly",
  usualy: "usually", wanna: "want to", gonna: "going to",
  // contractions (missing apostrophe)
  dont: "don't", doesnt: "doesn't", didnt: "didn't", cant: "can't",
  couldnt: "couldn't", wouldnt: "wouldn't", shouldnt: "shouldn't", wont: "won't",
  isnt: "isn't", arent: "aren't", wasnt: "wasn't", werent: "weren't",
  hasnt: "hasn't", havent: "haven't", hadnt: "hadn't", mustnt: "mustn't",
  wouldve: "would've", couldve: "could've", shouldve: "should've", mightve: "might've",
  im: "I'm", ive: "I've", youre: "you're", youve: "you've", youll: "you'll",
  youd: "you'd", theyre: "they're", theyve: "they've", theyll: "they'll",
  theyd: "they'd", weve: "we've", hes: "he's", shes: "she's", thats: "that's",
  whats: "what's", whos: "who's", theres: "there's", heres: "here's",
  wheres: "where's", hows: "how's", cmon: "c'mon", oclock: "o'clock",
};

export function matchCase(original, value) {
  // Values that already carry casing (contractions like "I'm") win.
  if (/[A-Z]/.test(value)) return value;
  if (original.length > 1 && original === original.toUpperCase()) return value.toUpperCase();
  if (/^[A-Z]/.test(original)) return value.charAt(0).toUpperCase() + value.slice(1);
  return value;
}

// Returns a corrected token, or null if nothing should change.
export function correctToken(word) {
  if (!word || !/[A-Za-z]/.test(word)) return null;
  if (word === "i") return "I";
  const lower = word.toLowerCase();
  if (Object.prototype.hasOwnProperty.call(TYPOS, lower)) return matchCase(word, TYPOS[lower]);
  // Fix an accidental double-capital start: "THe" -> "The" (leave acronyms like "NASA").
  if (/^[A-Z]{2}[a-z]+$/.test(word)) return word.charAt(0) + word.slice(1).toLowerCase();
  return null;
}
